import React from "react";
import { CircularProgress, Link } from "@material-ui/core";
import { errorToast } from "Modules/DPToast";

type Props = {
  onViewClick: () => Promise<void>;
};

const UserRosterTableViewButton = ({ onViewClick }: Props) => {
  const errorMessage =
    "File download failed. Please try again later or contact support (partner.support@dailypay.com).";
  const [isLoading, setIsLoading] = React.useState(false);

  const onClickViewHandler = async () => {
    try {
      setIsLoading(true);
      await onViewClick();
    } catch (e) {
      errorToast(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!isLoading ? (
        <Link style={{ cursor: "pointer" }} onClick={onClickViewHandler}>
          Download
        </Link>
      ) : (
        <CircularProgress size={30} />
      )}
    </>
  );
};

export default UserRosterTableViewButton;
